import ManageContentScreen from '../components/ManageContentScreen';

const ManageForms = () => {
  return (
    <ManageContentScreen
      type="forms"
      title="Manage Forms"
      backPath="/profile"
    />
  );
};

export default ManageForms;
